/**
 * Which round a position save records (job #115).
 *
 * The local position snapshot used to read `loadedRounds[engine.roundIndex]`.
 * Those are two different queues: at boot the engine holds a bootstrap WINDOW
 * (a pupil resuming at seed 50 had one round, S0050L01, at index 0) while
 * loadedRounds is later swapped for the full script (index 0 = S0001L01). The
 * first prompt after "Maybe later" then saved S0001L01 over the real place —
 * the wall moving a learner back to the start, which must never happen.
 *
 * The engine's own current round is the truth; the mirror is used only when it
 * agrees (it carries `seedId` and the full cycle list), or when the engine has
 * nothing yet.
 */
export interface SavableRound {
  legoId?: string | null
  seedId?: string | null
  cycles?: ReadonlyArray<{ id?: string | null } | null | undefined>
}

export function positionRoundForSave<E extends SavableRound, M extends SavableRound>(
  engineRound: E | null | undefined,
  mirroredRound: M | null | undefined,
): ((E | M) & { seedId: string | null }) | null {
  const pick: E | M | null | undefined = engineRound?.legoId
    ? (mirroredRound?.legoId === engineRound.legoId ? mirroredRound : engineRound)
    : mirroredRound
  if (!pick?.legoId) return null
  return { ...pick, seedId: pick.seedId ?? pick.legoId.slice(0, 5) }
}
